import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';

import { useResultsQueries } from '../data-access/queries/results';

export const useResultPage = () => {
  const { id } = useParams({
    from: '/_app/_admin/results_/$id',
  });
  const resultsQueries = useResultsQueries();
  const result = useSuspenseQuery({
    ...resultsQueries.detail(Number(id)),
    // This hook is consumed in parent + child components on the same page.
    // Keep data fresh enough but avoid an immediate second request on mount.
    staleTime: 60_000,
    refetchOnMount: false,
  });
  return { result };
};
